/* Mridaya Native menu drawer: account, shop, pages from the store menu, policies, WhatsApp. Replaces the feed's basic drawer. */
document.addEventListener('DOMContentLoaded', function () {
  const M = JSON.parse((document.getElementById('mn-menu-data') || {}).textContent || 'null');
  const F = JSON.parse((document.getElementById('mn-data') || {}).textContent || 'null');
  const oldBtn = document.getElementById('menuBtn'), oldDrawer = document.getElementById('drawer');
  if (!M || !oldBtn || !oldDrawer) return;
  const btn = oldBtn.cloneNode(true); oldBtn.replaceWith(btn);
  const drawer = oldDrawer.cloneNode(false); oldDrawer.replaceWith(drawer);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const T = (F && F.trust) || {};
  const wa = (T.whatsapp || '').replace(/[^0-9]/g, '');
  const pieces = F ? F.products.filter((p) => !F.hideNoImage || p.imgs.length).length : 0;
  const get = (k, d) => { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } };
  const cartCount = () => +((document.getElementById('badge') || {}).textContent || 0);
  const chev = '<svg class="mm__chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  const heart = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';
  const bag = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  const person = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg>';
  const story = M.links.find((l) => l.story);
  const contact = M.links.find((l) => l.contact);
  const pols = M.links.filter((l) => l.group === 'policies');
  const others = M.links.filter((l) => l.group === 'about' && l !== story && l !== contact);
  const key = (l) => 'l' + M.links.indexOf(l);

  function accountHTML() {
    const A = M.account;
    if (!A.enabled) return '';
    if (A.signedIn) return `<a class="mm__signin" href="${esc(A.account)}">${person}<span>${A.name ? esc(A.name) : 'Account'}</span></a>`;
    return `<a class="mm__signin" href="${esc(A.login)}">${person}<span>Sign in</span></a>`;
  }
  function row(label, k, meta) {
    return `<li><button class="mm__link" type="button" data-mm="${esc(k)}"><span>${esc(label)}</span>${meta != null ? `<small>${esc(meta)}</small>` : chev}</button></li>`;
  }
  function render() {
    const saved = get('mn-saved', []).length, cart = cartCount();
    drawer.innerHTML = `<nav class="mm" aria-label="Site menu">
      <div class="mm__head pad">
        <span class="mm__word">${esc((document.querySelector('.lockup__main') || {}).textContent || 'Menu')}</span>
        <div class="mm__head-r">${accountHTML()}<button class="mm__close" type="button" data-mm="close" aria-label="Close menu"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>
      </div>
      <div class="mm__body pad">
        ${story ? `<button class="mm__story" type="button" data-mm="${key(story)}">
          ${M.hero ? `<img alt="" src="${esc(M.hero)}">` : ''}
          <span class="mm__story-shade"></span>
          <span class="mm__story-text"><small>${esc(story.title)}</small><b>${esc(story.excerpt || 'How Mridaya Native began')}</b><em>Read the story ${chev}</em></span>
        </button>` : ''}
        <div class="mm__quick">
          <button type="button" data-mm="saved">${heart}<span>Saved</span><small>${saved}</small></button>
          <button type="button" data-mm="cart">${bag}<span>Cart</span><small>${cart}</small></button>
        </div>
        ${others.length ? `<ul class="mm__list">${others.map((l) => row(l.title, key(l))).join('')}</ul>` : ''}
        ${pols.length ? `<p class="mm__label">Policies</p><ul class="mm__list mm__list--small">${pols.map((l) => row(l.title, key(l))).join('')}</ul>` : ''}
        ${contact ? `<ul class="mm__list mm__list--contact">${row(contact.title, key(contact))}</ul>` : ''}
      </div>
      <div class="mm__foot pad">
        ${wa ? `<a class="mm__wa" href="https://wa.me/${wa}" target="_blank" rel="noopener"><span class="mm__wa-ic"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M20 11.5a8 8 0 0 1-11.8 7L4 20l1.5-4A8 8 0 1 1 20 11.5z"/><path d="M9.2 9.2c.2 1.9 1.7 3.9 3.8 4.8l1.1-1 1.6.8-.4 1.4c-3.3-.2-6.2-3-6.6-6.3l1.4-.4.8 1.6z" fill="currentColor" stroke="none"/></svg></span><span><small>Got questions?</small><b>Talk to us</b></span></a>` : ''}
        ${T.hours ? `<p class="mm__hours">${esc(T.hours)}</p>` : ''}
      </div>
    </nav>`;
  }
  function open() { render(); drawer.hidden = false; requestAnimationFrame(() => drawer.classList.add('is-open')); const c = drawer.querySelector('.mm__close'); if (c) c.focus({ preventScroll: true }); }
  function close() { drawer.classList.remove('is-open'); setTimeout(() => { drawer.hidden = true; }, 220); btn.focus({ preventScroll: true }); }
  function sheet(html, label) {
    const s = document.getElementById('sheet'), b = document.getElementById('sheetBack');
    if (!s || !b) return;
    s.innerHTML = '<div class="grab"></div>' + html; s.setAttribute('aria-label', label); b.hidden = false;
  }
  function contactExtra() {
    if (!wa && !T.email) return '';
    return `<div class="mm__contact">${wa ? `<a class="mm__wa" href="https://wa.me/${wa}" target="_blank" rel="noopener"><span class="mm__wa-ic"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M20 11.5a8 8 0 0 1-11.8 7L4 20l1.5-4A8 8 0 1 1 20 11.5z"/></svg></span><span><small>Fastest reply</small><b>Chat on WhatsApp</b></span></a>` : ''}${T.email ? `<p class="mm__mail">Email <span class="copyable">${esc(T.email)}</span></p>` : ''}</div>`;
  }
  btn.addEventListener('click', open);
  drawer.addEventListener('click', (e) => {
    if (e.target === drawer) { close(); return; }
    const b = e.target.closest('[data-mm]'); if (!b) return;
    const k = b.dataset.mm;
    if (k === 'close') { close(); return; }
    close();
    if (k === 'saved') { const s = document.querySelector('[data-story="-1"]'); if (s) s.click(); return; }
    if (k === 'cart') { const c = document.getElementById('cartBtn'); if (c) c.click(); return; }
    const l = M.links[+k.slice(1)]; if (!l) return;
    if (l.story) { location.href = l.url; return; }
    const tpl = l.tpl && document.getElementById(l.tpl);
    if (tpl) sheet(tpl.innerHTML + (l.contact ? contactExtra() : ''), l.title);
    else location.href = l.url;
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
  // Footer links: pages open in the same sheet as the menu; Our Story opens its own page.
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-mn-url]'); if (!a || e.metaKey || e.ctrlKey) return;
    const l = M.links.find((x) => x.url === a.dataset.mnUrl); if (!l || l.story) return;
    const tpl = l.tpl && document.getElementById(l.tpl); if (!tpl) return;
    e.preventDefault();
    sheet(tpl.innerHTML + (l.contact ? contactExtra() : ''), l.title);
  });
});
